export default "__VITE_ASSET__B1G1Nbyc__"